import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listAuditLog } from "@/lib/admin.functions";

export const Route = createFileRoute("/_authenticated/admin/audit-log")({
  component: AuditLogPage,
});

function AuditLogPage() {
  const fn = useServerFn(listAuditLog);
  const { data = [], isLoading } = useQuery({
    queryKey: ["audit-log"],
    queryFn: () => fn({ data: { limit: 200 } }),
    refetchOnWindowFocus: true,
  });

  return (
    <div>
      <h1 className="font-display text-3xl">Audit log</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Every booking, role and flag change is recorded automatically.
      </p>
      <div className="mt-8 rounded-2xl border border-border bg-card/30">
        {isLoading ? (
          <div className="p-6 text-sm text-muted-foreground">Loading…</div>
        ) : data.length === 0 ? (
          <div className="p-6 text-sm text-muted-foreground">No activity yet.</div>
        ) : (
          <ul className="divide-y divide-border">
            {data.map((r) => (
              <li key={r.id} className="grid gap-1 px-5 py-3 md:grid-cols-[160px_180px_1fr] md:items-center">
                <span className="text-xs text-muted-foreground">
                  {new Date(r.created_at).toLocaleString("en-IE")}
                </span>
                <span className="text-xs font-semibold uppercase tracking-wider text-primary">
                  {r.entity_type} · {r.action}
                </span>
                <code className="truncate text-xs text-muted-foreground">
                  {r.entity_id ?? "—"} {r.meta ? `· ${JSON.stringify(r.meta)}` : ""}
                </code>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
